import { useEffect, useState } from 'react';
import { usePrevious } from 'app/infrastructure/hooks';
import { Configuration } from 'app/components/metro-line/types';
import { ImportSetItemValidation } from '../types-store';
import { ImportSetSectionType } from './types';

export const useInvalidSection = (
  configuration: Configuration<ImportSetSectionType>[],
  validation: ImportSetItemValidation
): [Configuration<ImportSetSectionType>, React.Dispatch<React.SetStateAction<Configuration<ImportSetSectionType>>>] => {

  const [invalidSection, updateInvalidSection] = useState(configuration.find(configurationSection => !configurationSection.isValid));
  const previousValidation = usePrevious(validation);

  useEffect(() => {
    if (invalidSection === undefined && validation !== previousValidation
    ) {
      updateInvalidSection(configuration.find(configurationSection => !configurationSection.isValid));
    }
  }, [configuration, validation]);

  return [invalidSection, updateInvalidSection];
};
